import { render } from "./AddAdminModal.vue?vue&type=template&id=615714b0&scoped=true"
import script from "./AddAdminModal.vue?vue&type=script&lang=js"
export * from "./AddAdminModal.vue?vue&type=script&lang=js"

import "./AddAdminModal.vue?vue&type=style&index=0&id=615714b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615714b0"]])

export default __exports__